import { createSlice } from "@reduxjs/toolkit";

const roundToJoinSlice = createSlice({
  name: "roundToJoin",
  initialState: {
    loading: false,
    error: false,
    matchWeeks: '',
    pageCategory: "Round To Join",
    roundToJoinPotData: [],
    v2Fixtures: [],
  },
  reducers: {
    updateLoadingStatus: (state, payload) => {
      state.loading = true;
    },
    updateErrStatus: (state, payload) => {
      state.loading = false;
      state.error = true;
    },
    fetchRoundToJoinData: (state, payload) => {
      const { roundToJoinPot } = payload.payload;
      state.loading = false;
      state.roundToJoinPotData = roundToJoinPot;
    },
    fetchRoundPageCategory: (state, payload) => {
      state.loading = false;
      state.pageCategory = payload.payload;
    },
    updateV2Fixtures: (state, payload) => {
      state.loading = false;
      state.v2Fixtures = payload.payload;
    },
    updateMatchWeeks:(state, payload) => {
      state.loading = false;
      state.matchWeeks = payload.payload;
    }
  },
});

export const {
  fetchRoundPageCategory,
  updateLoadingStatus,
  updateErrStatus,
  fetchRoundToJoinData,
  updateV2Fixtures,
  updateMatchWeeks
} = roundToJoinSlice.actions;
export default roundToJoinSlice.reducer;
